import { URL_UPDATE_CONTACT } from 'constants/urls';

const updateContactApi = async (contact) => {
	const options = {
		method: 'POST',
		headers: { 'Content-Type': 'application/json;charset=UTF-8' },
		body: JSON.stringify({ payload: contact }),
	};
	const res = await fetch(URL_UPDATE_CONTACT, options);
	const data = await res.json();

	return data;
};

export default updateContactApi;
